// modulBaruConfig.js — Satu sumber kebenaran untuk kapan modul/soal baru
// (Interpretasi Gambar, Interpretasi Bentuk, sub-mode Hitung Huruf i di
// Kecermatan) mulai ikut masuk komposisi RESMI Tryout.
//
// LATAR BELAKANG: modul-modul ini ditambahkan di tengah minggu berjalan.
// Supaya tidak mengganggu peserta yang sedang/baru mau mengerjakan Tryout
// minggu ini, modul baru HANYA muncul di Latihan Harian dulu — baru ikut
// masuk roster resmi Tryout mulai tryout yang tanggal_mulai-nya >= tanggal
// di bawah ini (tryout yang dimulai 31 Agustus 2026 dan seterusnya).
//
// PENTING: tanggal_mulai tiap tryout TIDAK disimpan per-modul di database
// (tabel `tryouts` tidak punya kolom daftar modul) — roster modul resmi
// selalu dihitung dari konstanta di kode. Makanya gating ini murni
// perbandingan tanggal di frontend, bukan flag per tryout di DB.

export const TANGGAL_MODUL_BARU = '2026-08-31T00:00:00+07:00';

export function modulBaruAktif(tanggalMulaiTryout) {
  if (!tanggalMulaiTryout) return false;
  return new Date(tanggalMulaiTryout) >= new Date(TANGGAL_MODUL_BARU);
}

// id modul baru (dipakai TryoutScreen.jsx untuk susun roster resmi)
export const MODUL_BARU_IDS = ['interpretasigambar', 'interpretasibentuk'];
